import { module } from 'modujs';
import { gsap } from 'gsap';
import { lazyLoadImage } from '../utils/image';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.items = Array.from(this.$('slide'))

        this.resizeBind = this.onResize.bind(this)
        window.addEventListener('resize', this.resizeBind)

        this.onResize();

        this.tl = gsap.timeline({repeat: -1});

        gsap.set(this.items, { opacity: 0 })

        for(let i = 0; i < this.items.length; i++) {
            this.tl.set(this.items[i], { opacity: 1 })
            this.tl.set(this.items[i], { opacity: 0, delay: 1 })
        }
    }

    computeHeight(item) {
        return item.getBoundingClientRect().height;
    }

    lazyLoad() {
        this.$('image').forEach((image) => {
            lazyLoadImage(image)
        })
    }

    onResize() {
        this.el.style.height = `${this.computeHeight(this.items[0])}px`;
    }

    destroy() {
        super.destroy()
        window.removeEventListener('resize', this.resizeBind)
    }
}
